import { all, fork } from "redux-saga/effects";

import metaRoot from "./meta/sagas";
import roomRoot from "./room/sagas";
import boardRoot from "./board/sagas";
import surroundingRoot from "./surrounding/sagas";

export default function* root() {
  yield all([metaRoot(), roomRoot(), surroundingRoot(), boardRoot()]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js